// @flow

export type AlertData = {|
    title?: string,

    content?: string,
    message?: string,

    buttons?: Array<{|
        text: string,
        actions?: Array<string>
    |}>
|};

export const CSSDirection = {
    "ltr": "ltr",
    "rtl": "rtl",
};

export type CSSDirectionType = $Values<typeof CSSDirection>


// WEBPACK FOOTER //
// ./src/Store/Ducks/App/utils.js